import React, { useState } from "react";
import "./BusquedaPrecisa.css";
import { useNavigate } from "react-router-dom";
import fondo from "./ismaael.jpeg";
import MenuPrincipal from "./MenuPrincipal";

// 🔥 Carga automáticamente todas las exportaciones `infoManga` desde /pages
const context = require.context("./pages", true, /\.jsx$/);

const mangas = context
  .keys()
  .map((file) => {
    try {
      const mod = context(file);
      return mod.infoManga || null;
    } catch (error) {
      console.error("Error al cargar", file, error);
      return null;
    }
  })
  .filter(Boolean);

console.log("🧩 Mangas cargados:", mangas.map((m) => m.titulo));

export default function BusquedaPrecisa() {
  const [seleccionadas, setSeleccionadas] = useState([]);
  const [busquedaArtista, setBusquedaArtista] = useState("");
  const [busqueda, setBusqueda] = useState("");
  const [idiomaSeleccionado, setIdiomaSeleccionado] = useState("");
  const [tipoSeleccionado, setTipoSeleccionado] = useState("");
  const [visibleCount, setVisibleCount] = useState(6);

  const navigate = useNavigate();

  // Manejo etiquetas
  const toggleEtiqueta = (etiqueta) => {
    setSeleccionadas((prev) =>
      prev.includes(etiqueta)
        ? prev.filter((t) => t !== etiqueta)
        : [...prev, etiqueta]
    );

    setVisibleCount(6);
  };

  // Normalizar texto
  const normalizar = (texto) =>
    texto
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();

  // 🔥 FILTRO PRINCIPAL
  const resultados = mangas.filter((m) => {
    const titulo = normalizar(m.titulo);
    const busq = normalizar(busqueda);
const artistaBusq = normalizar(busquedaArtista);
    const coincideTitulo =
      busq.length < 3
        ? titulo.startsWith(busq)
        : titulo.includes(busq);
        const coincideArtista =
  artistaBusq === "" ||
  normalizar(m.info.artistas || "").includes(artistaBusq);

    const etiquetasManga = m.info.etiquetas.map(normalizar);

    const coincideEtiquetas =
      seleccionadas.length === 0 ||
      seleccionadas.every((t) =>
        etiquetasManga.includes(normalizar(t))
      );
const coincideIdioma =
  idiomaSeleccionado === "" ||
  normalizar(m.info.idioma) === normalizar(idiomaSeleccionado);
const coincideTipo =
  tipoSeleccionado === "" ||
  normalizar(m.info.tipo) === normalizar(tipoSeleccionado);

return (
  coincideTitulo &&
  coincideArtista &&
  coincideEtiquetas &&
  coincideIdioma &&
coincideTipo
);

});

  // 🔥 ORDENAR POR FECHA
  const resultadosOrdenados = resultados
    .filter((m) => m.fecha)
    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

  // 🔥 PAGINACIÓN
const mangasMostrar =
busqueda.trim() === "" &&
busquedaArtista.trim() === "" &&
seleccionadas.length === 0 &&
idiomaSeleccionado === "" &&
tipoSeleccionado === ""
    ? []
    : resultadosOrdenados.length > 0
      ? resultadosOrdenados.slice(0, visibleCount)
      : [];

  // Etiquetas únicas
  const etiquetasDisponibles = [
    ...new Set(mangas.flatMap((m) => m.info.etiquetas)),
  ].sort((a, b) => a.localeCompare(b));

  // Ver más
  const mostrarMas = () => {
    setVisibleCount((prev) => prev + 6);
  };

  return (
    <div>

      {/* HEADER */}
      <header
        className="header-fondo"
        style={{
          background: `url(${fondo}) no-repeat center center/cover`,
          padding: "40px 0",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <h1
          className="titulo"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          TMOXNight
        </h1>

<MenuPrincipal
  onIdiomaSelect={(idioma) => {
    setIdiomaSeleccionado(idioma);
    setVisibleCount(6);
  }}
/>
      </header>

      {/* CONTENIDO */}
      <div className="busqueda-holo">

        <h1 className="titulo">
          🔍 Búsqueda Precisa de Mangas
        </h1>

        {/* BUSCADOR */}
        <input
          type="text"
          placeholder="Buscar por nombre del manga..."
          value={busqueda}
          onChange={(e) => {
            setBusqueda(e.target.value);
            setVisibleCount(6);
          }}
          className="buscador-input"
        />

        <input
  type="text"
  placeholder="Buscar por artista..."
  value={busquedaArtista}
  onChange={(e) => {
    setBusquedaArtista(e.target.value);
    setVisibleCount(6);
  }}
  className="buscador-input"
/>
{/* FILTROS ACTIVOS */}
{/* FILTROS ACTIVOS */}
<div className="filtros-box">

  <div className="filtros-activos">

    {idiomaSeleccionado && (
      <div className="filtro-activo">
        {idiomaSeleccionado}

        <span
          onClick={() => setIdiomaSeleccionado("")}
        >
          ✕
        </span>
      </div>
    )}

    {tipoSeleccionado && (
      <div className="filtro-activo">
        {tipoSeleccionado}

        <span
          onClick={() => setTipoSeleccionado("")}
        >
          ✕
        </span>
      </div>
    )}

    {seleccionadas.map((tag) => (
      <div
        key={tag}
        className="filtro-activo"
      >
        {tag}

        <span
          onClick={() => toggleEtiqueta(tag)}
        >
          ✕
        </span>
      </div>
    ))}

  </div>

  {idiomaSeleccionado && (
    <div className="filtro-activo">
      {idiomaSeleccionado}

      <span
        onClick={() => setIdiomaSeleccionado("")}
      >
        ✕
      </span>
    </div>
  )}

  {tipoSeleccionado && (
    <div className="filtro-activo">
      {tipoSeleccionado}

      <span
        onClick={() => setTipoSeleccionado("")}
      >
        ✕
      </span>
    </div>
  )}

  {seleccionadas.map((tag) => (
    <div
      key={tag}
      className="filtro-activo"
    >
      {tag}

      <span
        onClick={() => toggleEtiqueta(tag)}
      >
        ✕
      </span>
    </div>
  ))}

</div>
        {/* ETIQUETAS */}
        <div className="etiquetas-scroll">
          <div className="etiquetas-inner">
            {etiquetasDisponibles.map((etiqueta) => (
              <button
                key={etiqueta}
                onClick={() => toggleEtiqueta(etiqueta)}
                className={`etiqueta-btn ${
                  seleccionadas.includes(etiqueta)
                    ? "seleccionada"
                    : ""
                }`}
              >
                {etiqueta}
              </button>
            ))}
          </div>
        </div>

      {/* RESULTADOS */}

{busqueda.trim() === "" &&
busquedaArtista.trim() === "" &&
seleccionadas.length === 0 &&
idiomaSeleccionado === "" &&
tipoSeleccionado === "" ? (

  <p className="no-result glow-text">
    ✨ Escribe algo o elige etiquetas para empezar
  </p>

) : mangasMostrar.length > 0 ? (

  <>

    <div className="resultados-container">

      {mangasMostrar.map((m, i) => (
    <div key={i}>

      {/* CARD */}
      <div
        className="manga-holo-card"
       onClick={() =>
  navigate(
    m.enlace ||
    `/comic/${m.titulo
      .toLowerCase()
      .replace(/[\s-]+/g, "")
      .replace(/[^a-z0-9]/g, "")}`
  )
}
        style={{ cursor: "pointer" }}
      >
        <div className="face front">
          <img src={m.portada} alt={m.titulo} />
        </div>

        <div className="face back">
          <img
            src={m.reverso || m.portada}
            alt={m.titulo}
          />
        </div>
      </div>

      {/* TITULO */}
      <div
        className="manga-title-busqueda"
     onClick={() =>
  navigate(
    m.enlace ||
    `/comic/${m.titulo
      .toLowerCase()
      .replace(/[\s-]+/g, "")
      .replace(/[^a-z0-9]/g, "")}`
  )
}
        style={{ cursor: "pointer" }}
      >
        {m.titulo}
      </div>

      {/* INFO */}
      <div className="info-extra">
<p>
  <strong>Tipo:</strong>

  <span
    className="mini-tag"
    style={{ marginLeft:"8px", cursor:"pointer" }}
    onClick={() => {
      setTipoSeleccionado(m.info.tipo);
      setVisibleCount(6);
    }}
  >
    {m.info.tipo}
  </span>
</p>        <p><strong>Idioma:</strong> {m.info.idioma}</p>
        <p><strong>Serie:</strong> {m.info.serie}</p>

        <div className="mini-tags">
          {m.info.etiquetas
            .slice(0, 3)
            .map((tag, idx) => (
              <span
                key={idx}
                className="mini-tag"
              >
                {tag}
              </span>
            ))}
        </div>
      </div>

    </div>
  ))}

     </div>

    {/* VER MÁS */}
    {visibleCount < resultadosOrdenados.length && (
      <div
        className="load-more-bar"
        onClick={mostrarMas}
      >
        LOAD MORE ▼
      </div>
    )}

  </>
          ) : (

            <p className="no-result">
              No se encontraron mangas 😢
            </p>

          )}

             </div>
    </div>
  );
}